import React from 'react'
import { ChatAttachment } from 'types/Chat'
import { ChatAttachmentItem } from 'components/data/ChatAttachmentItem/ChatAttachmentItem'
import * as Styled from './ChatAttachmentList.styles'

interface ChatAttachmentListProps {
  attachments?: ChatAttachment[]
  onRemoveAttachment?: (id: string) => void
  disabled?: boolean
  align?: 'left' | 'right'
}

const ChatAttachmentList: React.FC<ChatAttachmentListProps> = ({
  attachments,
  onRemoveAttachment,
  disabled,
  align = 'left',
}) => {
  if (!attachments?.length) return null

  return (
    <Styled.ListContainer $align={align} data-testid='chat-attachment-list'>
      {attachments.map((attachment) => (
        <ChatAttachmentItem
          key={attachment.id}
          name={attachment.name}
          size={attachment.size}
          type={attachment.type}
          onRemove={onRemoveAttachment && (() => onRemoveAttachment(attachment.id))}
          disabled={disabled}
        />
      ))}
    </Styled.ListContainer>
  )
}

export { ChatAttachmentList }
